import Hashes from 'jshashes'
import * as R from 'ramda'
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux'
import { ThunkMiddleware } from 'redux-thunk'

import { State } from '~redux/store'
import { setCookie as setCookieAction } from '~shared-components/redux/actions/cookies.actions'
import { heapIdentifyUser } from '~shared-components/redux/actions/login.actions'

const setCookie = (cookieName: string, value: string) => {
  const encodedValue = encodeURIComponent(value)
  const cookie = `${cookieName}=${encodedValue}`

  if (window && window.document) {
    document.cookie = cookie
  }
}

export const persistCookieMiddleware: ThunkMiddleware<State> = () => (
  next: Dispatch,
) => (action: AnyAction) => {
  if (setCookieAction.match(action)) {
    Object.entries(action.payload).forEach(([key, val]) =>
      setCookie(
        typeof key === 'string' ? key : R.toString(key),
        typeof val === 'string' ? val : R.toString(val),
      ),
    )
  }
  return next(action)
}

/**
 * This middleware is used to trigger a route change on the
 * initial client load. This allows the client thunks attached to
 * routes to work both on initial load and on client side navigation.
 */
export const triggerClientThunkMiddleware: ThunkMiddleware<State> = (
  api: MiddlewareAPI,
) => (next: Dispatch) => (action: AnyAction) => {
  if (action.type === 'CLIENT_LOAD') {
    const { payload, query, type } = api.getState().location
    api.dispatch({ payload, query, type })
  } else {
    return next(action)
  }
}

declare global {
  interface Window {
    heap: {
      identify: (userId: string) => void
      load: (appId: string) => void
    }
  }
}

export const heapIdentifyUserMiddleware: ThunkMiddleware<State> = () => (
  next: Dispatch,
) => (action: AnyAction) => {
  if (heapIdentifyUser.match(action)) {
    const sha256 = new Hashes.SHA256()
    window.heap?.identify(sha256.hex(action.payload))
  }
  return next(action)
}
